import { render, staticRenderFns } from "./contest-quiz-section-config.html?vue&type=template&id=6c3f7acd&scoped=true&"
import script from "./contest-quiz-section-config.js?vue&type=script&lang=js&"
export * from "./contest-quiz-section-config.js?vue&type=script&lang=js&"
import style0 from "./contest-quiz-section-config.scss?vue&type=style&index=0&id=6c3f7acd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3f7acd",
  null
  
)

export default component.exports